/**
 * Página de producto - Libro
 * Controla: cambio de miniatura, lightbox de zoom, carruseles con flechas
 * (relacionados y aleatorios) y selección aleatoria real de "otros títulos".
 */
function initProductoLibro(sectionId) {
  var root = document.getElementById('producto-libro-' + sectionId);
  if (!root || root.dataset.libroInit === 'true') return;
  root.dataset.libroInit = 'true';

  initMiniaturas(root, sectionId);
  initZoom(root);
  initVariantes(root);
  initCarousel(document.getElementById('relacionados-track-' + sectionId));
  initAleatorios(sectionId);
}

/* ---------------------------------------------------------------------- */
/* Variantes: actualiza el input hidden "id" según las opciones elegidas   */
/* ---------------------------------------------------------------------- */
function initVariantes(root) {
  var selects = root.querySelectorAll('.producto-libro-variante-select');
  var variantInput = root.querySelector('.producto-libro-variant-id');
  var addBtn = root.querySelector('.producto-libro-btn-agregar');
  if (!selects.length || !variantInput) return;

  var productJsonEl = root.querySelector('[data-product-json]');
  var variantsData = [];
  if (productJsonEl) {
    try {
      variantsData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      variantsData = [];
    }
  }

  function actualizarVariante() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantsData.find(function (v) {
      return v.options.length === seleccion.length &&
        v.options.every(function (opt, idx) { return opt === seleccion[idx]; });
    });

    if (match) {
      variantInput.value = match.id;
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.labelDisponible || addBtn.textContent;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelAgotado || 'Agotado';
        }
      }
    }
  }

  selects.forEach(function (select) {
    select.addEventListener('change', actualizarVariante);
  });
}

/* ---------------------------------------------------------------------- */
/* Miniaturas                                                              */
/* ---------------------------------------------------------------------- */
function initMiniaturas(root, sectionId) {
  var miniaturas = root.querySelectorAll('.producto-libro-miniatura');
  var imgPrincipal = document.getElementById('producto-libro-img-principal-' + sectionId);
  if (!miniaturas.length || !imgPrincipal) return;

  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      miniaturas.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var fullSrc = btn.getAttribute('data-full-src');
      var srcset = btn.getAttribute('data-srcset');
      var alt = btn.getAttribute('data-alt');

      if (fullSrc) imgPrincipal.src = fullSrc;
      if (srcset) imgPrincipal.srcset = srcset;
      if (alt) imgPrincipal.alt = alt;
    });
  });
}

/* ---------------------------------------------------------------------- */
/* Zoom / Lightbox                                                         */
/* ---------------------------------------------------------------------- */
function initZoom(root) {
  var trigger = root.querySelector('[data-zoom-trigger]');
  var wrap = root.querySelector('[data-zoom-habilitado]');
  var lightbox = root.querySelector('[data-lightbox]');
  if (!lightbox) return;

  var lightboxImg = lightbox.querySelector('[data-lightbox-img]');
  var cerrarBtn = lightbox.querySelector('[data-lightbox-cerrar]');

  function abrir() {
    var imgPrincipal = root.querySelector('.producto-libro-imagen-principal');
    if (!imgPrincipal) return;
    lightboxImg.src = imgPrincipal.src;
    lightboxImg.alt = imgPrincipal.alt;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function cerrar() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', abrir);
  if (wrap) {
    var img = wrap.querySelector('.producto-libro-imagen-principal');
    if (img) img.addEventListener('click', abrir);
  }
  if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) cerrar();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });
}

/* ---------------------------------------------------------------------- */
/* Carrusel genérico con flechas                                           */
/* ---------------------------------------------------------------------- */
function initCarousel(track) {
  if (!track || track.dataset.carouselInit === 'true') return;
  track.dataset.carouselInit = 'true';

  var container = track.closest('.producto-libro-carousel-container');
  if (!container) return;

  var prevBtn = container.querySelector('.producto-libro-nav-prev');
  var nextBtn = container.querySelector('.producto-libro-nav-next');
  if (!prevBtn || !nextBtn) return;

  function getScrollAmount() {
    var item = track.querySelector('.producto-libro-carousel-item');
    if (!item) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var itemWidth = item.getBoundingClientRect().width + gap;
    var visible = Math.max(1, Math.floor(track.clientWidth / itemWidth));
    var step = Math.max(1, Math.floor(visible / 2));
    return itemWidth * step;
  }

  function updateButtonsState() {
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  }

  prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });
  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(updateButtonsState);
  });
  window.addEventListener('resize', updateButtonsState);

  updateButtonsState();
}

/* ---------------------------------------------------------------------- */
/* Otros títulos al azar: selecciona N candidatos al azar del pool         */
/* ---------------------------------------------------------------------- */
function initAleatorios(sectionId) {
  var track = document.getElementById('aleatorios-track-' + sectionId);
  if (!track) return;

  var config = (window.__productoLibroConfig && window.__productoLibroConfig[sectionId]) || {};
  var cantidad = config.cantidadAleatorios || 8;

  var candidatos = Array.prototype.slice.call(track.querySelectorAll('[data-aleatorio-candidato]'));
  if (!candidatos.length) return;

  // Fisher-Yates shuffle
  for (var i = candidatos.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = candidatos[i];
    candidatos[i] = candidatos[j];
    candidatos[j] = tmp;
  }

  var seleccionados = candidatos.slice(0, cantidad);
  var seleccionadosSet = new Set(seleccionados);

  candidatos.forEach(function (item) {
    if (seleccionadosSet.has(item)) {
      item.style.display = '';
      track.appendChild(item); // reordena para que queden agrupados al inicio
    } else {
      item.remove();
    }
  });

  initCarousel(track);
}
